import React from 'react';
import { Link } from 'react-router-dom';
import Nav from '../components/Nav/Nav';

function Terms() {
  return (
    <div>
      <Nav home />
      <div className='wrapper-container legal-container'>
        <div className='wrapper-content'>

          <div className='title-wrapper'>
            <h2>Mentions Légales</h2>
          </div>

          <h2><strong>Éditeur du site</strong></h2>
          <p>
            Fastline<br />
            Exploité par : M. Randy Lele Talla<br />
            Statut : Entrepreneur individuel<br />
            SIRET : 828 983 254 00032<br />
            Email : <a href="mailto:randy@fastlineapp.com">randy@fastlineapp.com</a>
          </p>

          <br />

          <h2><strong>Hébergement</strong></h2>
          <p>
            Le site est hébergé par Firebase (Google LLC)<br />
            1600 Amphitheatre Parkway<br />
            Mountain View, CA 94043, États-Unis
          </p>

          <br />

          <h2><strong>Propriété intellectuelle</strong></h2>
          <p>
            L’ensemble du contenu du site (textes, images, logos, etc.) est la propriété exclusive de Fastline, sauf mention contraire.
            Toute reproduction ou utilisation sans autorisation est interdite.
          </p>

          <br />

          <h2><strong>Responsabilité</strong></h2>
          <p>
            Fastline est une plateforme permettant à des professionnels (vendeurs, commerçants, restaurateurs ou prestataires)
            de proposer leurs produits ou services en ligne.
          </p>
          <p>
            Fastline agit exclusivement en tant qu’intermédiaire technique.
            Le contrat de vente est conclu directement entre le client et le vendeur.
          </p>
          <p>
            Le vendeur est seul responsable :
          </p>
          <ul>
            <li>des produits ou services proposés</li>
            <li>des prix affichés</li>
            <li>de l’exécution des commandes</li>
            <li>de la livraison le cas échéant</li>
          </ul>
          <p>
            Fastline ne peut être tenu responsable des litiges commerciaux entre un client et un vendeur.
          </p>

          <br />

          <h2><strong>Paiements</strong></h2>
          <p>
            Les paiements sont traités de manière sécurisée via Stripe.
            Fastline agit en tant qu’intermédiaire technique et peut percevoir une commission sur les transactions.
          </p>

          <br />

          <h2><strong>Droit applicable</strong></h2>
          <p>
            Le présent site est soumis au droit français.
          </p>

          <br />

          <h2><strong>Documents complémentaires</strong></h2>
          <p>
            L’utilisation de la plateforme est encadrée par les documents suivants :
          </p>

          <ul className="legal-links">
            <li style={{textDecoration:'underline'}}>
              <Link to="/terms-of-service">Conditions Générales d’Utilisation</Link>
            </li>
            <li style={{textDecoration:'underline'}}>
              <Link to="/terms-of-sale">Conditions Générales de Vente</Link>
            </li>
            <li style={{textDecoration:'underline'}}>
              <Link to="/privacy-policy">Politique de confidentialité</Link>
            </li>
            <li style={{textDecoration:'underline'}}>
              <Link to="/cookie-policy">Politique de cookies</Link>
            </li>
          </ul>

          <p>
            Ces documents précisent les règles d’utilisation du service, les conditions de commande ainsi que la gestion de vos données personnelles.
          </p>

        </div>
      </div>
    </div>
  );
}

export default Terms;